import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { DsStatusTagComponent } from "./ds-status-tag.component";
import { DsIconModule } from "../ds-icon/ds-icon.module";
import { DsLoaderModule } from "../ds-loader/ds-loader.module";

@NgModule({
  declarations: [DsStatusTagComponent],
  imports: [CommonModule, MatProgressSpinnerModule, DsIconModule, DsLoaderModule],
  exports: [DsStatusTagComponent],
})
export class DsStatusTagModule {}
